import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { timeUtc: String }

  connect() {
    this.convertUtcToLocal()
  }

  convertUtcToLocal() {
    const utcString = this.timeUtcValue
    if (!utcString) return

    const localDate = new Date(utcString)
    const formatted = `${localDate.getFullYear()}-${
      String(localDate.getMonth() + 1).padStart(2, "0")
    }-${String(localDate.getDate()).padStart(2, "0")} ${
      String(localDate.getHours()).padStart(2, "0")
    }:${String(localDate.getMinutes()).padStart(2, "0")}`

    if (this.element.tagName === "INPUT") {
      this.element.value = formatted
    } else {
      this.element.textContent = formatted
    }
  }
}
